<style>
tr.visible_0 td {
    background-color: #ffcccc !important;
}
</style>

<template>

    <!-- Content -->
    <div class="admin-content">

        <div class="d-flex align-items-center justify-content-between flex-wrap mb-3">
            <!-- Left -->
            <div>
                <h5 class="mb-0 fw-semibold text-color">Staff Management</h5>
                <p class="mb-0 text-muted small">
                    Manage your staffs
                </p>
            </div>
            <!-- Right -->
            <button v-if="user.role == 1" class="btn-primary" data-bs-toggle="modal" data-bs-target="#addNewStaff">
                <i class="fas fa-plus me-2"></i>
                Add New Staff
            </button>
        </div>

        <div class="row">
            <div class="col-md-3 col-sm-6 grid-col mob-mt">
                <div class="dashbord-card">
                    <div class="d-flex justify-content-between">
                        <div>
                            <p class="card-p text-md">Admins</p>
                            <p class="card-big-p text-color">
                                <PriceFormat :Price="admins.length" />
                            </p>
                        </div>
                        <div class="pr-card-label-btn bg-dark-lighter primary-color"><span
                                class="fas fa-users icon-size"></span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-3 col-sm-6 grid-col mob-mt">
                <div class="dashbord-card">
                    <div class="d-flex justify-content-between">
                        <div>
                            <p class="card-p text-md">Operators</p>
                            <p class="card-big-p text-color">
                                <PriceFormat :Price="operators.length" />
                            </p>
                        </div>
                        <div class="pr-card-label-btn bg-dark-lighter purple-color"><span
                                class="fas fa-users icon-size"></span>
                        </div>
                    </div>


                </div>
            </div>

            <div class="col-md-3 col-sm-6 grid-col mob-mt">
                <div class="dashbord-card">
                    <div class="d-flex justify-content-between">
                        <div>
                            <p class="card-p text-md">Sales </p>
                            <p class="card-big-p text-color">
                                <PriceFormat :Price="sales.length" />
                            </p>
                        </div>
                        <div class="pr-card-label-btn bg-dark-lighter green-color"><span
                                class="fas fa-users icon-size"></span>
                        </div>
                    </div>


                </div>
            </div>

            <div class="col-md-3 col-sm-6 grid-col mob-mt">
                <div class="dashbord-card">
                    <div class="d-flex justify-content-between">
                        <div>
                            <p class="card-p text-md">Total Staffs</p>
                            <p class="card-big-p text-color">
                                <PriceFormat :Price="staffs.length" />
                            </p>
                        </div>
                        <div class="pr-card-label-btn bg-dark-lighter red-color">
                            <span class="fas fa-users icon-size"></span>
                        </div>
                    </div>


                </div>
            </div>
        </div>
        <div v-if="searching" class="mt-1">
            <div class="text-center">
                <div class="spinner-grow text-success" role="status"></div>
                <div class="spinner-grow text-danger" role="status"></div>
                <div class="spinner-grow text-warning" role="status"></div>
            </div>
        </div>

        <!--admin---->
        <div class="row align-items-stretch">
            <div class="col-12">
                <div class="card recent-orders-card mt-3">

                    <!-- Card Header -->
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <h5 class="mb-0 fw-semibold">
                            <span class="text-color">Admins</span>
                        </h5>
                        <!--router-link :to="{ path: '/order' }"
              class="text-primary text-sm decolation-none">
              View All
            </router-link-->

                    </div>

                    <!-- Card Body -->
                    <div class="card-body p-0">
                        <div class="table-responsive">
                            <table class="table orders-table mb-0">
                                <thead class="">
                                    <tr>

                                        <th class="td-wd-user">CLIENT</th>
                                        <th class="td-wd">CONTACTS</th>
                                        <th class="td-wd">LOCATION</th>
                                        <th class="td-wd">ASSIGN'S</th>
                                        <th class="td-wd">CANCELS</th>
                                        <th class="td-wd text-end">CREATED AT</th>


                                        <!--th class="text-end td-wd-sm">ACTION</th-->
                                    </tr>
                                </thead>
                                <tbody>

                                    <tr :class="'visible_' + admin.status" v-for="admin in admins" :key="admin.id">

                                        <td class="text-white text-sm">
                                            <UserAvatar class="text-bold" v-if="admin.avator == 'user.jpg'"
                                                :fullName="admin.name" imageUrl="" />
                                            <UserAvatar v-else :fullName="admin.name"
                                                :imageUrl="this.$store.state.img_url + admin.avator" />
                                        </td>
                                        <td class="text-color text-bold">
                                            <PhoneFormat :Phone="admin.email" />
                                        </td>

                                        <td class="text-color text-sm">{{ admin.location }}</td>
                                        <td class="text-primary text-bold text-sm">
                                            <PriceFormat :Price="admin.assigns" /> Order's
                                        </td>
                                        <td class="text-danger text-bold text-sm">
                                            <PriceFormat :Price="admin.canceled" /> Order's
                                        </td>
                                        <td class="text-green text-bold text-sm text-end">
                                            <DateFormat :Date_="admin.created_at" />
                                        </td>

                                        <!--td class="text-end fw-semibold text-sm">
                                            <div class="order-actions">
                                                <button @click="addConfirmModel(admin)" data-bs-toggle="modal"
                                                    data-bs-target="#editModel"
                                                    class="order-action-btn text-primary edit" title="Edit">
                                                    <i class="fas fa-eye"></i> Details
                                                </button>

                                            </div>
                                        </td-->
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <!--operator-->
        <div class="row align-items-stretch">
            <div class="col-12">
                <div class="card recent-orders-card mt-3">

                    <!-- Card Header -->
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <h5 class="mb-0 fw-semibold">
                            <span class="text-color">Operator's</span>
                        </h5>
                        <!--router-link :to="{ path: '/order' }"
              class="text-primary text-sm decolation-none">
              View All
            </router-link-->

                    </div>

                    <!-- Card Body -->
                    <div class="card-body p-0">
                        <div class="table-responsive">
                            <table class="table orders-table mb-0">
                                <thead class="">
                                    <tr>

                                        <th class="td-wd-user">CLIENT</th>
                                        <th class="td-wd">CONTACTS</th>
                                        <th class="td-wd">LOCATION</th>
                                        <th class="td-wd">COMPLETE'S</th>
                                        <th class="td-wd">CANCELS</th>
                                        <th class="td-wd text-end">CREATED AT</th>


                                        <th v-if="user.role == 1" class="text-end td-wd-sm">ACTION</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    <tr :class="'visible_' + operator.status" v-for="operator in operators"
                                        :key="operator.id">

                                        <td class="text-white text-sm">
                                            <UserAvatar class="text-bold" v-if="operator.avator == 'user.jpg'"
                                                :fullName="operator.name" imageUrl="" />
                                            <UserAvatar v-else :fullName="operator.name"
                                                :imageUrl="this.$store.state.img_url + operator.avator" />
                                        </td>
                                        <td class="text-color text-bold">
                                            <PhoneFormat :Phone="operator.email" />
                                        </td>

                                        <td class="text-color text-sm">{{ operator.location }}</td>
                                        <td class="text-primary text-bold text-sm">
                                            <PriceFormat :Price="operator.completes" /> Order's
                                        </td>
                                        <td class="text-danger text-bold">
                                            <PriceFormat :Price="operator.canceled" /> Order's
                                        </td>
                                        <td class="text-green text-bold text-sm text-end">
                                            <DateFormat :Date_="operator.created_at" />
                                        </td>

                                        <td v-if="user.role == 1" class="text-end fw-semibold text-sm">
                                            <div class="order-actions">
                                                <button @click="editModel(operator)" data-bs-toggle="modal"
                                                    data-bs-target="#editModel"
                                                    class="order-action-btn text-primary edit" title="Edit">
                                                    <i class="fas fa-pen"></i> Edit
                                                </button>

                                            </div>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <!--sale-->
        <div class="row align-items-stretch">
            <div class="col-12">
                <div class="card recent-orders-card mt-3">

                    <!-- Card Header -->
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <h5 class="mb-0 fw-semibold">
                            <span class="text-color">Sales's</span>
                        </h5>
                        <!--router-link :to="{ path: '/order' }"
              class="text-primary text-sm decolation-none">
              View All
            </router-link-->

                    </div>

                    <!-- Card Body -->
                    <div class="card-body p-0">
                        <div class="table-responsive">
                            <table class="table orders-table mb-0">
                                <thead class="">
                                    <tr>

                                        <th class="td-wd-user">CLIENT</th>
                                        <th class="td-wd">CONTACTS</th>
                                        <th class="td-wd">LOCATION</th>
                                        <th class="td-wd">CONFIRM'S</th>
                                        <th class="td-wd">CANCELS</th>
                                        <th class="td-wd text-end">CREATED AT</th>


                                        <th v-if="user.role == 1" class="text-end td-wd-sm">ACTION</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    <tr :class="'visible_' + sale.status" v-for="sale in sales" :key="sale.id">

                                        <td class="text-white text-sm">
                                            <UserAvatar class="text-bold" v-if="sale.avator == 'user.jpg'"
                                                :fullName="sale.name" imageUrl="" />
                                            <UserAvatar v-else :fullName="sale.name"
                                                :imageUrl="this.$store.state.img_url + sale.avator" />
                                        </td>
                                        <td class="text-color text-bold">
                                            <PhoneFormat :Phone="sale.email" />
                                        </td>

                                        <td class="text-color text-sm">{{ sale.location }}</td>
                                        <td class="text-primary text-bold text-sm">
                                            <PriceFormat :Price="sale.confirmed" /> Order's
                                        </td>
                                        <td class="text-danger text-bold">
                                            <PriceFormat :Price="sale.canceled" /> Order's
                                        </td>
                                        <td class="text-green text-bold text-sm text-end">
                                            <DateFormat :Date_="sale.created_at" />
                                        </td>

                                        <td v-if="user.role == 1" class="text-end fw-semibold text-sm">
                                            <div class="order-actions">
                                                <button @click="editModel(sale)" data-bs-toggle="modal"
                                                    data-bs-target="#editModel"
                                                    class="order-action-btn text-primary edit" title="Edit">
                                                    <i class="fas fa-pen"></i> Edit
                                                </button>

                                            </div>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            </div>
        </div>


        <!--add new statt-->
        <div class="modal fade" id="addNewStaff" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false">

            <div class="modal-dialog modal-dialog-centered modal-md">
                <div class="modal-content custom-modal-style">

                    <!-- HEADER -->
                    <div class="modal-header custom-modal-header d-flex justify-content-between align-items-center">

                        <h5 class="modal-title mb-0">New Staff</h5>
                        <button type="button" class="btn-close ms-3 text-white fas fa-xmark" data-bs-dismiss="modal">
                        </button>
                    </div>

                    <!-- BODY -->
                    <div class="modal-body custom-modal-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-8">

                                 <div class="form-group mt-2">
                                    <label for="">Fullname</label>
                                    <input type="text" v-model="form.username" placeholder="full name" class="form-control">    
                                </div>

                                 <div class="form-group mt-2">
                                    <label for="">Phone</label>
                                    <input type="text" v-model="form.phone" placeholder="0xxxxxxxxx" class="form-control">    
                                </div>

                                 <div class="form-group mt-2">
                                    <label for="">Location</label>
                                    <input type="text" v-model="form.location" placeholder="full name" class="form-control">    
                                </div>

                                <div class="form-group mt-2">
                                    <label for="">User Role</label>
                                    <select v-model="form.role" class="form-control">
                                        <option value="2">Operator</option>
                                        <option value="3">Sales</option>
                                    </select>
                                </div>



                                 <button type="button" @click="createStaff()" class="btn-primary font-bold mt-3">
                  <i class="fas fa-check me-2"></i>
                  Create New Staff 
                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--add new statt-->
        <div class="modal fade" id="editModel" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false">

            <div class="modal-dialog modal-dialog-centered modal-md">
                <div class="modal-content custom-modal-style">

                    <!-- HEADER -->
                    <div class="modal-header custom-modal-header d-flex justify-content-between align-items-center">

                        <h5 class="modal-title mb-0">Edit Staff</h5>
                        <button type="button" class="btn-close ms-3 text-white fas fa-xmark" data-bs-dismiss="modal">
                        </button>
                    </div>

                    <!-- BODY -->
                    <div class="modal-body custom-modal-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-6">
                                 <p class="mb-1 text-muted text-capitalize">Fullname : {{ staff.name }}</p>
                 <p class="mb-1 text-muted">Phone No : {{ staff.email }}</p>
                 <p v-if="staff.role == 2" class="mb-1 text-primary">Complete Orders : {{ staff.completes }}</p>
                 <p v-if="staff.role == 3" class="mb-1 text-primary">Confirmed Orders : {{ staff.confirmed }}</p>
                 <p class="mb-1 text-danger">Canceled Orders : {{ staff.canceled }}</p>
                 <p class="mb-1 text-muted text-xs">{{ staff.created_at }}</p>
                            </div>
                            <div class="col-sm-12 col-md-6">
                                <div class="form-group mt-2">
                                    <label for="">User Status</label>
                                    <select v-model="staff.status" class="form-control">
                                        <option value="1">Active</option>
                                        <option value="0">InActive</option>

                                    </select>
                                </div>

                                <div class="form-group mt-2">
                                    <label for="">User Role</label>
                                    <select v-model="staff.role" class="form-control">
                                        <option value="3">Sales</option>
                                        <option value="2">Operator</option>
                                        <option value="1">Admin</option>


                                    </select>
                                </div>

                                  <button type="button" @click="updateStaff()" class="btn-primary font-bold mt-3">
                  <i class="fas fa-check me-2"></i>
                  Update User 
                </button>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import UserAvatar from "@/components/UserAvatar.vue";
import OrderStatus from "@/components/OrderStatus.vue";
import PriceFormat from "@/components/PriceFormat.vue";
import PhoneFormat from "@/components/PhoneFormat.vue";
import DateFormat from "@/components/DateFormat.vue";

export default {
    components: {
        UserAvatar,
        OrderStatus,
        PriceFormat,
        PhoneFormat,
        DateFormat
    },
    data() {
        return {
            searching: false,
            admins: [],
            sales: [],
            operators: [],
            staffs: [],
            staff: {},
            form:{
                role:2,
                username:"",
                location:"",
                phone:""
            },
            user: this.$attrs.user
        };
    },
    methods: {
        editModel(staff) {
            this.staff = staff
        },

      async updateStaff(){
    
        var id = this.staff.id
        var role = this.staff.role
        var status = this.staff.status

var response = await axios.post(this.$store.state.api_url + "/update-staff", {id, role, status})
    .catch((errors) => {

        var message = "Network or Request Errors";
        this.$toast.error(message, { duration:5000, dismissible: true });
      });
      if (response.data.success) {

        window.location.reload()

      } else {
          var message = response.data.message
          this.$toast.error(message, { duration:5000, dismissible: true });
        
      }

        },
         async createStaff(){
    
           var form = this.form

var response = await axios.post(this.$store.state.api_url + "/create-staff", form)
    .catch((errors) => {

        var message = "Network or Request Errors";
        this.$toast.error(message, { duration:5000, dismissible: true });
      });
      if (response.data.success) {

        window.location.reload()

      } else {
          var message = response.data.message
          this.$toast.error(message, { duration:5000, dismissible: true });
        
      }

        },
        async staffDatas() {
            this.searching = true
            var response = await axios
                .get(this.$store.state.api_url + "/staff-datas")
                .catch((errors) => {
                    this.searching = false
                    var message = "Network or Server Errors";
                    this.$toast.error(message, { duration: 5000, dismissible: true });
                });

            console.log(response.data)
            if (response.data.success) {
                this.searching = false
                var staffs = response.data.staffs

                this.staffs = staffs;

                var admins = staffs.filter(function (obj) {
                    return obj.role == 1;
                });

                var operators = staffs.filter(function (obj) {
                    return obj.role == 2;
                });

                var sales = staffs.filter(function (obj) {
                    return obj.role == 3;
                });

                this.sales = sales
                this.operators = operators
                this.admins = admins

            } else {

                this.searching = false
                var message = response.data.message;
                this.$toast.error(message, { duration: 5000, dismissible: true });
            }
        }

    },
    created() {
        this.$store.state.page_name = "Staffs"
        this.staffDatas()

    },
};
</script>
